import React from 'react';

import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { OrganizationFormValues } from '@/modules/onboarding/organization-setup';
import { DayOfWeek } from '@/types/day-of-week';

import { WorkDayScheduleField } from './work-day-schedule-field';

interface ScheduleFieldProps {
  control: Control<OrganizationFormValues>;
}

export const ScheduleField: React.FC<ScheduleFieldProps> = ({ control }) => {
  const { t } = useTranslation(['common', 'authenticated.organization']);

  return (
    <div className="rounded-lg border border-input p-4">
      <div>
        <h3 className="text-sm font-medium">
          {t('authenticated.organization:workingHours.title')}
        </h3>
        <p className="text-xs text-muted-foreground">
          {t('authenticated.organization:workingHours.description')}
        </p>
      </div>
      <table className="mt-[1.125rem] border-separate border-spacing-y-3">
        <tbody>
          {Object.keys(DayOfWeek).map((dayOfWeek: DayOfWeek) => (
            <WorkDayScheduleField
              key={dayOfWeek}
              control={control}
              dayOfWeek={dayOfWeek}
              label={t(`authenticated.organization:workingHours.days.${dayOfWeek.toString()}`)}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
